/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC } from 'react';
import { Card, Typography } from 'antd';
import { PLAN_TYPE_LABELS } from 'constants/profile';
import { t } from 'i18next';

import { IPlanItemProps } from './types';
import { StyledList, StyledPrice } from './styled';
import { money } from 'utils/price';
import { parseJson } from 'utils/json';

const { Paragraph } = Typography;
const { Meta } = Card;

// Edit/delete actions were already commented out pre-migration; the dead
// DELETE_PLAN Apollo mutation was dropped with the REST port.
const PlanItem: FC<IPlanItemProps> = ({
  id,
  name,
  type,
  duration,
  description,
  price,
  features
}) => {
  const featuresArr = parseJson(features) || [];
  const subtitle = `${t(`profile.${PLAN_TYPE_LABELS[type]}`)}${
    duration ? ` | ${duration}h` : ''
  }`;

  return (
    <Card
      title={name}
      style={{ height: '100%' }}
      // extra={[
      //   <IconButton
      //     key={`plan-item-edit-${id}`}
      //     mode="transparent"
      //     onClick={() => toggleModal('plans', true, { id })}
      //   >
      //     <EditOutlined />
      //   </IconButton>,
      //   <IconButton
      //     key={`plan-item-delete-${id}`}
      //     mode="transparent"
      //     onClick={onDeleteClick}
      //   >
      //     <DeleteOutlined style={{ color: 'var(--danger-color)' }} />
      //   </IconButton>
      // ]}
    >
      <Meta description={subtitle} />
      <Paragraph style={{ marginTop: 16 }}>{description}</Paragraph>
      {/* <StyledPrice>{money(price)}</StyledPrice> */}
      {!!featuresArr.length && (
        <StyledList>
          {featuresArr.map((item: string, index: number) => (
            <li key={`feature-item-${index}`}>{item}</li>
          ))}
        </StyledList>
      )}
    </Card>
  );
};

export default PlanItem;
